import { Component } from '@angular/core';

@Component({
  selector: 'lib-navigate-back',
  templateUrl: './navigate-back.component.html',
  styleUrls: ['./navigate-back.component.scss'],
})
export class NavigateBackComponent {}
